import useHighlight from "./useHighlight";
import useCalculator from "./useCalculator";
import useSpreadsheet from "./useSpreadsheet";
import useScratchPad from "./useScratchPad";
import useWordProcessor from "./useWordProcessor";
import useStrikethrough from "./useStrikethrough";
import useSymbol from "./useSymbol";

const useExamControls = () => {
  const hightlight = useHighlight();
  const calculator = useCalculator();
  const spreadsheet = useSpreadsheet();
  const scratchPad = useScratchPad();
  const wordProcessor = useWordProcessor();
  const strikethrough = useStrikethrough();
  const symbol = useSymbol();
  return {
    hightlight,
    calculator,
    spreadsheet,
    scratchPad,
    wordProcessor,
    strikethrough,
    symbol,
  };
};

export default useExamControls;
